import { render, staticRenderFns } from "./CateList.vue?vue&type=template&id=69063fec&"
import script from "./CateList.vue?vue&type=script&lang=js&"
export * from "./CateList.vue?vue&type=script&lang=js&"
import style0 from "./CateList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports